<template>
  <a-modal v-model="visible" :title="$t(title)" width="500px" :maskClosable="false" @cancel="handleCancel" :footer="null">
    <div class="organization">
      <a-form :form="form" class="form" @submit="handleSubmit">
        <div style="width:110px;float:left;margin-top:5px;">
          <upload ref="upload" :length="1" :imgs="logo" @uploadSuccess="uploadSuccess" :cutImg="true" :uploadTest="$t('上传logo')"></upload>
        </div>
        <div style="width:340px;float:right;">
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('单位名称')" :disabled="userInfo.remark === '北京学校账号'" :placeholder="$t('请输入单位名称')" v-decorator="['unitName', { rules: [{required: true, whitespace:true, message: $t('请输入单位名称')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('单位简称')" :placeholder="$t('请输入单位简称')" v-decorator="['abbreviation', { rules: [{required: true, whitespace:true, message: $t('请输入单位简称')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('联系人员')" :placeholder="$t('联系人员')" v-decorator="['contacts', { rules: [{required: true, message: $t('联系人员')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('联系电话')" :placeholder="$t('请输入联系电话')" v-decorator="['mobiles', {rules: [{required: true, message: $t('请输入联系电话')}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">{{ $t('单位类型') }}</span>
            <a-select style="width:200px;" :placeholder="$t('请选择单位类型')" v-decorator="['unitType',{ rules: [{ required: true, message: $t('请选择单位类型') }] },]">
              <a-select-option :value="item.code" v-for="item in matchFun.agencyTypeEnum()" :key="item.code">{{$t(item.name)}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">{{ $t('所属地区') }}</span>
            <a-cascader style="width:260px;" :options="address" :placeholder="$t('请选择地区')" v-decorator="['regionCode', {rules: [{ required: true, message: $t('请选择地区')}],initialValue: ['500000','500100','500191']}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input :addon-before="$t('详细地址')" :placeholder="$t('请输入详细地址')" v-decorator="['address', { rules: [{required: true, message: $t('请输入详细地址')}]}]"/>
          </a-form-item>
        </div>
        <a-button style="margin-left:180px;" @click="handleSubmit" type="primary">
          {{$t('提交数据')}}
        </a-button>
      </a-form>
    </div>
    <AgencyMsg ref="agencyMsg"/>
  </a-modal>
</template>

<script>
import address from '@comm/config/address'
import Upload from '@comm/upload/Upload'
import AgencyMsg from './AgencyMsg'
import matchFun from '@comm/utils/matchFun'
import { getAddressFullCodeByCode } from '@comm/utils/addressUtil'
import { mapState } from 'vuex'
export default {
  name: 'EditAgency',
  components: {
    AgencyMsg,
    Upload
  },
  data () {
    return {
      matchFun: matchFun,
      title: '创建单位信息',
      visible: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      data: null,
      logo: [],
      address: address,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    show (data) {
      this.data = data
      if (this.data !== null) {
        this.title = '编辑单位信息'
        this.formData()
      } else {
        setTimeout(() => {
          this.form.setFieldsValue({
            mobiles: this.userInfo.account
          })
        })
      }
      this.visible = true
    },
    formData () {
      setTimeout(() => {
        this.form.setFieldsValue({
          unitName: this.data.unitName,
          abbreviation: this.data.abbreviation,
          mobiles: this.data.mobiles,
          contacts: this.data.contacts,
          address: this.data.address,
          unitType: this.data.unitType,
          regionCode: getAddressFullCodeByCode(this.data.area + '')
        })
        this.logo = [this.matchFun.randomNumFile('logo.jpg', this.data.unitLogo)]
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 去掉名称中的空格
          values.unitName = values.unitName.replace(/\s/g, '')
          if (values.unitName.length < 4) {
            this.$message.error('单位名称至少四个字！')
            return
          }
          if (values.abbreviation.length > 5) {
            this.$message.error('单位简称不能超过五个字!')
            return
          }
          if (this.logo.length === 0) {
            values.unitLogo = 'https://static.daoba.com//221980219035.jpg'
          } else {
            values.unitLogo = this.logo[0].url
          }
          values.provinceCode = values.regionCode[0]
          values.cityCode = values.regionCode[1]
          values.area = values.regionCode[2]
          values.parentId = 0
          values.programId = 0
          if (this.data !== null) {
            values.agencyId = this.data.agencyId
            this.update(values)
          } else {
            this.register(values)
          }
        }
      })
    },
    update (valData) {
      this.$api.high.updateAgency(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.emitData(valData)
          this.handleCancel()
        } else {
          this.$message.warn(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    register (valData) {
      this.$api.high.registerAgency(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.emitData(null)
          this.handleCancel()
        } else {
          if (res.status === 201) {
            this.$refs.agencyMsg.show(res.data)
          }
          this.$message.warn(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    uploadSuccess (e) {
      this.logo = e
    },
    handleCancel () {
      this.visible = false
    },
    emitData (valData) {
      if (valData === null) {
        this.$emit('ok', null)
      } else {
        this.data.unitName = valData.unitName
        this.data.abbreviation = valData.abbreviation
        this.data.unitLogo = valData.unitLogo
        this.data.provinceCode = valData.provinceCode
        this.data.cityCode = valData.cityCode
        this.data.area = valData.area
        this.data.mobiles = valData.mobiles
        this.data.contacts = valData.contacts
        this.data.address = valData.address
        this.data.unitType = valData.unitType
        this.$emit('ok', this.data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.organization{
  .title{
    color: #000;
    line-height: 50px;
    font-size: 16px;
    position: relative;
    .add-right-warp{
      position: absolute;
      right: 0;
      top: 0;
    }
    .add-right{
      display: inline-block;
      cursor: pointer;
      color: #000;
      border-radius: 2px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      padding: 0 10px;
      border: 1px solid #e8e8e8;
    }
  }
  .list{
    .col{
      margin-bottom: 30px;
      float: left;
      width: 50%;
      &:nth-child(odd){
        .warp{
          margin-left: 3%;
        }
      }
    }
    .warp{
      width: 97%;
      height: 120px;
      border:1px solid #e8e8e8;
      border-radius: 2px;
      display: flex;
      flex-direction: row;
      position: relative;
      background-color:#fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      &:hover{
        cursor: pointer;
        background-color: #f7f7f7;
      }
      .or-img{
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-top: auto;
        margin-bottom: auto;
        padding: 10px;
      }
      .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        div{
          flex: 1;
          color: #000;
          line-height: 40px;
          margin-bottom: 0;
          .or-title{
            color: #999;
          }
        }
      }
      .check{
        position: absolute;
        right: 0;
        color: #fff;
        width: 80px;
        font-size: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: #e8e8e8;
      }
    }
    .active{
      .check{
        background-color: red;
      }
    }
  }
}
.organization /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-cascader-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/EditAgency.vue